import { IFormFieldType } from '@/widgets/create-widget'
import { MediaType } from '@/constants/constants'

const FacultySectionSchema: { [key: string]: IFormFieldType } = {
  facultySection: {
    type: 'Object',
    label: 'Faculty Section',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      subHeading: {
        type: 'String',
        label: 'Sub Heading',
        required: false,
      },
      faculties: {
        type: 'List',
        label: 'Faculties',
        required: false,
        children: {
          name: {
            type: 'String',
            label: 'Title',
            required: false,
          },
          miniDescription: {
            type: 'String',
            label: 'Mini Description',
            required: false,
          },
          image: {
            type: 'Media',
            mediaTypes: [MediaType.IMAGE],
            label: 'Teacher Image',
            required: false,
          },
          video: {
            type: 'Media',
            mediaTypes: [MediaType.VIDEO],
            label: 'Teacher Video',
            required: false,
          },
          details: {
            type: 'Object',
            label: 'Details',
            required: false,
            children: {
              designation: {
                type: 'String',
                label: 'Title',
                required: false,
              },
              multi_description: {
                type: 'List',
                label: 'Multi Line Description',
                required: false,
                children: {
                  description: {
                    type: 'String',
                    label: 'Description',
                    required: false,
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}

export default FacultySectionSchema

export type FacultyProps = {
  name: string
  miniDescription: string
  image: string
  video?: string
  details: {
    designation: string
    multi_description: { description: string }[]
  }
}

export type FacultySectionProps = {
  heading: string
  subHeading: string
  faculties: FacultyProps[]
}

export type Faculty = {
  facultySection: FacultySectionProps
}

export const FacultySectionDefaultValues: Faculty = {
  facultySection: {
    heading: 'Meet our Faculty',
    subHeading: 'Our teachers are no less than wizards! 💫',
    faculties: [
      {
        name: 'Vishal Sir',
        miniDescription: 'B. Sc. Graduate, CTET and HTET qualified with 4+years of teaching experience.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/733a4787-82fe-41db-bca3-907fc9a31a1f.webp',
        details: {
          designation: 'Maths Gold Medallist in Maths',
          multi_description: [
            { description: 'Meet Vishal Sir, your versatile educator' },
            { description: 'B Tech Electronics & communication (ECE)' },
            { description: 'Mentored 2+ Lakh Students' },
            { description: '4+ Years of Experience' },
            { description: 'Produced Top Ranks in competitive exams' },
          ],
        },
      },
      {
        name: "Shivangi Ma'am",
        miniDescription: 'M.sc in Physics and B.Ed in physical science, 4+ years of experience.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/bf8d54df-ab7d-43e5-9fa5-7a78ac805129.webp',
        details: {
          designation: 'Experience in both Science and Maths',
          multi_description: [
            { description: 'Catered students of CBSE, ICSE and various state boards' },
            { description: 'Produced good results in olympiad' },
            { description: 'Closely worked with behaviour challenged students' },
            { description: 'Mentored students in both online and offline mode' },
          ],
        },
        video:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/d82c8eb7-6c40-4b8e-99ac-1ff5924ee76d.mp4',
      },
      {
        name: "Areebah Ma'am",
        miniDescription: 'BSc. Honors in Mathematical Physics with 4+ years of teaching experience.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/8c736fe5-6fb8-4dd8-b035-d1945f47cf2d.webp',
        details: {
          designation: 'Transforming Math into a fun-filled adventure ride!',
          multi_description: [
            { description: 'Catered students of CBSE, ICSE and various state boards' },
            { description: 'Conducted 2000+ live online Math & Olympiad sessions' },
            { description: '4+ yrs Expereince with Maths & Physics' },
          ],
        },
      },
      {
        name: "Chetna Ma'am",
        miniDescription:
          'M. SC in Mathematics + B.Ed, CTET and HTET qualified, 5+ years of teaching experience.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/f5dea361-3cbb-45cd-bb02-ab349eaa156e.webp',
        details: {
          designation: 'Expertise in empowering students with Math Skills',
          multi_description: [
            { description: 'Conducted 5k+ live Maths + Olympiad sessions (online+offline)' },
            { description: 'Guided students of CBSE,ICSE and various state boards' },
            { description: 'Taught students from USA as well' },
          ],
        },
      },
      {
        name: "Sonakshi Ma'am",
        miniDescription: 'M.Sc in Zoology. 3+ years of Online teaching experience.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/82f51ace-c717-4f5d-9008-6f402e2c6c94.webp',
        details: {
          designation: 'Expertise in Biology',
          multi_description: [
            { description: 'Have been teaching science through experimental and experiential techniques' },
            { description: 'Master of students of grades 3 to 8' },
            { description: 'Expert Online Educator' },
          ],
        },
        video:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/7b82bc6d-d394-44c3-a847-5e34a20a42c8.mp4',
      },
      {
        name: 'Deepak Sir',
        miniDescription: 'B.Tech, 5 years of experience. Mentored more than 50,000 students.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/a09adc2d-3581-4988-b054-6b2b0a5b30e0.webp',
        details: {
          designation: 'Taught for 11th NEET & Olympiads',
          multi_description: [
            { description: 'Taught in across grade 3- 11 over past 5 years' },
            { description: 'Students qualified NTSE, NSEJS' },
            { description: 'Mentored over 50K+ students' },
          ],
        },
      },
      {
        name: "Zufa Ma'am",
        miniDescription: 'B.Sc. in Zoology, B.Ed , CTET Paper -2 Qualified, 6+ Years of teaching experience.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/070be48c-5850-4d94-90e4-b4ede94009f6.webp',
        details: {
          designation: 'Fostering critical thinking and a deep understanding of science',
          multi_description: [
            { description: 'Catered students of CBSE, ICSE and various state boards' },
            { description: 'Conducted 3000+ live sessions.  Olympiad sessions' },
            { description: 'Follows Activity- based learning' },
          ],
        },
      },
      {
        name: "Trayee Ma'am",
        miniDescription:
          'M.Sc in Botany, B.ed, CTET+BTET(Paper1 and 2) Qualified, 5 years teaching experience.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/9efe8500-618e-42d5-a457-824ccc77a10e.webp',
        details: {
          designation: 'Expertise in Biology and Chemistry',
          multi_description: [
            { description: 'Catered students of CBSE, ICSE and State boards' },
            { description: 'MSc in Botany & completed B.Ed' },
            { description: 'CTET & BTET Qualified Educator' },
          ],
        },
        video:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/68ebf967-a343-4f3f-bce7-830f542ce936.mp4',
      },
      {
        name: "Tubia Ma'am",
        miniDescription: 'Masters in Biotechnology with 5 years of teaching experience.',
        image:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/655d6cc8-7251-4f9c-8aab-e95822c6e060.webp',
        details: {
          designation: 'Science unleashed through real-world analogies!',
          multi_description: [
            { description: 'Catered students of CBSE, ICSE and State boards' },
            { description: 'Conducted 500 plus live Biolgy sessions across PAN India' },
            { description: 'Expert teacher in Biotechnology' },
          ],
        },
        video:
          'https://static.pw.live/5eb393ee95fab7468a79d189/GLOBAL_CMS/a29158e2-bcab-43aa-b86f-46feddc5dd6b.mp4',
      },
    ],
  },
}
